const envVars = process.env;

const confVars = Object.keys(envVars)
  .filter(key => key.startsWith('APP_CONFIG_'))
  .map(key => ({ [key]: envVars[key] }))
  .reduce((result, current) => ({ ...result, ...current }), {})

confVars.NODE_ENV = envVars.NODE_ENV || 'development'
confVars.GIT_COMMIT = envVars.GIT_COMMIT
confVars.isDevelopment = confVars.NODE_ENV === 'development'

module.exports = confVars;
